import React, { FC } from 'react'
import Button from '../../components/Button'

interface IUnavailableProductsBannerProps {
  onGoToPlan: () => void
}

const UnavailableProductsBanner: FC<IUnavailableProductsBannerProps> = ({
  onGoToPlan,
}) => {
  return (
    <div className="order-modal_unavailable-banner">
      <div className="order-modal_unavailable-banner_content">
        <div className="order-modal_unavailable-banner_info">
          <div className="order-modal_unavailable-banner_title">
            UNAVAILABLE PRODUCTS
          </div>
          <div className="order-modal_unavailable-banner_text">
            Some products are no longer available for purchase. Update your{' '}
            <span
              className="order-modal_unavailable-banner_link"
              onClick={onGoToPlan}
            >
              Replenishment Plan
            </span>{' '}
            or simply delete them to finish the order.
          </div>
        </div>
        <Button
          type="button"
          color="primary"
          className="order-modal_unavailable-banner_button"
          onClick={onGoToPlan}
        >
          GO TO PLAN
        </Button>
      </div>
    </div>
  )
}

export default UnavailableProductsBanner
